import _ from 'lodash'

export var tools = {
    options: {},
    openExternal: function (url) {
        tools.logEvent('open_external', {url})
        if (window.cordova.platformId == 'browser') {
            return window.open(url, "_blank")
        } else {
            return window.cordova.InAppBrowser.open(url, '_system')
        }
    },
    openInternal: function (url) {
        tools.logEvent('open_internal', {url})
        if (window.cordova.platformId == 'browser') {
            return window.open(
                url,
                "internal", "menubar=no, status=no, scrollbars=yes, menubar=no, width=500, height=500")
        } else {
            return window.cordova.InAppBrowser.open(url, '_blank', 'location=no,closebuttoncaption=Fermer')
        }
    },
    arrayToObject: function (array) {
        return array.reduce((obj, item) => {
            obj[item.id] = item
            return obj
        }, {})
    },
    pickRandom: function (items) {
        return items[Math.floor(Math.random() * items.length)]
    },
    logEvent: function (name, params) {
        try {
            console.log('Log event', name, params || {})
            if (window.FirebasePlugin) {
                window.FirebasePlugin.logEvent(name, params || {})
            } else if (window.dataLayer) {
                params.event = 'custom_event'
                params.event_name = name
                window.dataLayer.push(params)
                window.dataLayer.push({
                    'eventCategory': 'toptv',
                    'eventAction': name,
                    'eventLabel': name,
                    'eventValue': params.id || 0,
                    'event': 'gaevent'
                });
            }
        } catch (e) {
            console.log("Log event error", e)
        }
    },
    isPhone: window.screen.height < 800 || window.screen.width < 800,
    displayDuration(duration) {
        if (isNaN(duration)) duration = 0
        duration = Math.floor(duration)
        let s = duration%60
        let m = Math.floor(duration/60)%60
        let h = Math.floor(duration/3600)%24
        let j = Math.floor(duration/86400)
        let result = _.padStart(m, 2, 0)+':'+_.padStart(s,2,0)
        if (h > 0) {
            result = _.padStart(h, 2, 0) + ':' + result
        }
        if (j > 0) {
            result = j + 'j ' + result
        }
        return result
    },
}

export const ToolsPlugin = {}
ToolsPlugin.install = function (Vue, options) {
    tools.options = options
    if (window.cordova.platformId == 'browser' && window.CDV_origSymbols && window.CDV_origSymbols['window.open']) {
        // Restore browser native window.open in browser
        window.open = window.CDV_origSymbols['window.open']
    }
    Object.defineProperty(Vue.prototype, '$tools', {
        get() { return tools }
    })
}

